<template>
  <div class="company-manage">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="审核情况">
        <el-select style="width: 120px" clearable size="mini" v-model="searchForm.isWork" placeholder="请选择">
          <el-option
            v-for="item in passStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区">
        <el-cascader
          clearable
          size="mini"
          style="width: 250px"
          v-model="searchForm.provinceAndCityAndCounty"
          :options="provinceAndCityAndCountyOption"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button type="primary" size="mini" @click="onCreate">创建单位</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="companyName" label="单位名称"></el-table-column>
      <el-table-column prop="principal" label="负责人"></el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type==1">卡券</span>
          <span v-if="scope.row.type==2">黄金</span>
        </template>
      </el-table-column>
      <el-table-column prop="tel" label="联系方式"></el-table-column>
      <el-table-column prop="createTime" :formatter="dateFormatter" label="入驻日期"></el-table-column>
      <el-table-column prop="channelLimitName" label="频道权限"></el-table-column>
      <el-table-column prop="isWork" label="审核通过">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork == '1'"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="isPassChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="viewCompany(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteCompany(scope.row)"
            type="text"
            size="small">
            删除
          </el-button>
          <el-button
            @click.native.prevent="backendUrlView(scope.row)"
            type="text"
            size="small">
            后台地址
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="40%"
    :before-close="handleClose">
    <el-form ref="companyForm" :model="companyForm" :rules="rules" label-width="120px" style="padding:0 40px 0 0">
      <el-form-item label="单位名称" prop="companyName">
        <el-input v-model="companyForm.companyName"></el-input>
      </el-form-item>
      <el-form-item label="单位简介" prop="introduce">
        <el-input type="textarea" :rows="2" v-model="companyForm.introduce"></el-input>
      </el-form-item>
      <el-form-item label="省市区" prop="provinceAndCityAndCounty">
        <el-cascader
          clearable
          style="width: 100%"
          v-model="companyForm.provinceAndCityAndCounty"
          :options="provinceAndCityAndCountyOption"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="addressDetail">
        <el-input v-model="companyForm.addressDetail"></el-input>
      </el-form-item>
      <el-form-item label="负责人" prop="principal">
        <el-input v-model="companyForm.principal"></el-input>
      </el-form-item>
      <!-- <el-form-item label="类型" prop="type">
        <el-select v-model="companyForm.type" placeholder="请选择">

          <el-option v-for="t in companyType"
          :key="t.value"
            :label="t.label"
            :value="t.value"
            value-key="value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="电话" prop="tel">
        <el-input v-model.number="companyForm.tel"></el-input>
      </el-form-item>
      <el-form-item label="频道权限" prop="channelLimit">
        <el-checkbox-group v-model="companyForm.channelLimit">
          <el-checkbox v-for="channel in channelList" :key="channel.id" :label="channel.id" name="channelLimit">{{channel.channelName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button v-loading="saveLoading" type="primary" @click="submitForm">确 定</el-button>
        </span>
  </el-dialog>
    <el-dialog
      title="后台地址"
      :visible.sync="backendUrlDialogVisible"
      width="40%">
      <span>{{backendUrlString}}</span>
    </el-dialog>
  </div>
</template>

<script>
  import { CodeToText,regionDataPlus } from 'element-china-area-data'
  import utils from '../utils/utils'
  export default {
    name: "company-manage",
    data(){
      return{
        companyType:[{label:'卡券',value:1},{label:'黄金',value:2}],
        passStatus:[{
          label:"审核通过",
          value:1
        },{
          label:"审核未通过",
          value:0
        }],
        provinceAndCityAndCountyOption:regionDataPlus,
        saveLoading:false,
        searchForm:{
          isWork:null,
          provinceAndCityAndCounty:[],
          keyWords:""
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        dialogTitle:"",
        dialogVisible:false,
        action:"",
        companyForm:{
          companyName:"",
          introduce:"",
          provinceAndCityAndCounty:[],
          addressDetail:"",
          principal:"",
          tel:"",
          channelLimit:[]
        },
        channelList:[],
        rules: {
          companyName: [{required: true, message: '请输入单位名称', trigger: 'blur'},{ min: 1, max: 30, message: "长度在 1 到 30 个字符", trigger: "blur" }],
          introduce: [{required: true, message: '请输入单位简介', trigger: 'blur'}],
          provinceAndCityAndCounty: [{required: true, message: '请选择省市区', trigger: 'change'}],
          addressDetail: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
          principal: [{required: true, message: '请输入负责人', trigger: 'blur'}],
          tel: [{required: true, message: '请输入联系电话', trigger: 'blur'},
        {pattern: /^[123456789]\d{7,10}$/, message: "请输入正确的联系电话", trigger: "blur" }],
          channelLimit: [{type: 'array',required: true, message: '请选择频道权限', trigger: 'change'}],
          type: [{required: true, message: '请选择类型', trigger: 'change'}],
        },
        companyId:null,
        backendUrlDialogVisible:false,
        backendUrlString:""
      }
    },
    created(){
      this.getData()
      this.getChannelDataAll();
    },
    methods:{
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.pageInfo.total = response.data.total;
            this.tableData = response.data.list;
            this.tableData.map(row => {
              row.channelList =[];
              const ids = row.channelAll.split(',');
              const names = row.channelAllName.split(',');
              for (let i in ids){
                row.channelList.push({id: Number(ids[i]),channelName: names[i]});
              }
              // this.getChannelData(row,(res) =>{
              //   row.channelList = res.data.list;
              // })
            })
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:"/api/platform/queryCompanyA",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            isWork:this.searchForm.isWork,
            province:this.searchForm.provinceAndCityAndCounty? this.searchForm.provinceAndCityAndCounty[0]:"",
            city:this.searchForm.provinceAndCityAndCounty? this.searchForm.provinceAndCityAndCounty[1]:"",
            county:this.searchForm.provinceAndCityAndCounty? this.searchForm.provinceAndCityAndCounty[2]:"",
            keyWords:this.searchForm.keyWords
          },
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      onSearch(){
        this.getData();
      },
      onCreate(){
        this.getChannelDataAll();
        this.dialogVisible = true;
        this.dialogTitle = "创建单位";
        this.action = "add";
      },
      getChannelDataAll(){
        utils.axiosMethods({
          method: "GET",
          url: "/api/shop/queryChannelAll",
          callback:(res => {
            this.channelList = res.data.list
          })
        })
      },
      getChannelData(row,callback){
        utils.axiosMethods({
          method: "GET",
          url: "/api/shop/queryChannelAllByCompanyId",
          params:{
            companyId:row.id
          },
          callback:(res => {
            callback(res);
          })
        })
      },
      isPassChange(row){
        let isWork = row.isWork == '1' ? '0':'1';
        utils.axiosMethods({
          method: "GET",
          url: "/api/platform/changePassStatus",
          params:{
            id:row.id,
            isWork:isWork
          },
          callback:(res => {
            this.$message.success("操作成功");
            this.getData();
          })
        })
      },
      handleClose(){
        this.dialogVisible = false;
        this.companyForm = {
          companyName:"",
          introduce:"",
          provinceAndCityAndCounty:[],
          addressDetail:"",
          principal:"",
          tel:"",
          channelLimit:[]
        }
        this.companyId = null;
        this.$refs["companyForm"].resetFields();
      },
      submitForm(){
        if(this.saveLoading)
        return;
        //验证表单
        this.$refs["companyForm"].validate((valid) => {
          if(valid){
            this.saveLoading = true;
            let url,formData;
            formData = {
              companyName:this.companyForm.companyName,
              introduce:this.companyForm.introduce,
              province:this.companyForm.provinceAndCityAndCounty[0],
              city:this.companyForm.provinceAndCityAndCounty[1],
              county:this.companyForm.provinceAndCityAndCounty[2],
              addressDetail:this.companyForm.addressDetail,
              principal:this.companyForm.principal,
              tel:this.companyForm.tel,
             // type:this.companyForm.type,
              channelLimit:this.companyForm.channelLimit.join(",")
            }
            if(this.action == "add"){
              url = "/api/platform/insertCompanyA"
            }else{
              url = "/api/platform/updateCompanyA"
              formData.id = this.companyId
            }
            utils.axiosMethods({
              method: "POST",
              url: url,
              data:formData,
              callback:(res => {
                this.dialogVisible = false;
                this.saveLoading = false;
                if(this.action == "add"){
                  this.$message.success("创建成功");
                }else{
                  this.$message.success("修改成功");
                }
                this.getData();
              })
            })
          }
        })
      },
      viewCompany(row){
        this.dialogTitle = "编辑单位";
        this.dialogVisible = true;
        this.action = "update";
        this.companyId = row.id;
        this.channelList = row.channelList;
        this.companyForm = {
          companyName:row.companyName,
          introduce:row.introduce,
          provinceAndCityAndCounty:[row.province,row.city,row.county],
          addressDetail:row.addressDetail,
          principal:row.principal,
          tel:row.tel,
       //   type:row.type,
          channelLimit:row.channelLimit.split(',').map(channel => channel = parseInt(channel))
        }
      },
      deleteCompany(row){
        utils.axiosMethods({
          method: "GET",
          url: "/api/platform/deleteCompanyA",
          params: {
            id: row.id,
          },
          callback: (res => {
            this.$message.success("删除成功");
            this.getData();
          })
        })
      },
      backendUrlView(row){
        this.backendUrlDialogVisible = true;
        this.backendUrlString = row.backAddress;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index){
        return utils.dateFormat(cellValue)
      },
      // 省市显示中文
      codeToText(str){
        return CodeToText[str]
      }
    }
  }
</script>

<style scoped lang="less">
  .company-manage{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/companyManage.vue